import { render, staticRenderFns } from "./LinkGateway.vue?vue&type=template&id=36f74b56&scoped=true&"
import script from "./LinkGateway.vue?vue&type=script&lang=js&"
export * from "./LinkGateway.vue?vue&type=script&lang=js&"
import style0 from "./LinkGateway.vue?vue&type=style&index=0&id=36f74b56&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f74b56",
  null
  
)

export default component.exports